import { Link } from 'react-router-dom';

const Footer = () => {
	return (
		<footer id="footer">
			<div>
				<div className="top">
					<ul className="clause">
						<li>
							<Link to="/regulation/terms" className="gs-underline-item effect">
								<span className="line">이용약관</span>
							</Link>
						</li>
						<li>
							<Link to="/regulation/policy" className="gs-underline-item effect policy">
								<span className="line">
									<strong>개인정보 처리방침</strong>
								</span>
							</Link>
						</li>
						<li>
							<Link to="/regulation/email" className="gs-underline-item effect">
								<span className="line">이메일집단수신거부</span>
							</Link>
						</li>
					</ul>
				</div>

				<div>
					<ul className="info">
						<li>
							<address>주소 : 03080 서울특별시 종로구 대학로 101(연건동 28)</address>
						</li>
					</ul>
					<div className="copyright">
						<Link
							to="https://www.snuh.org/main.do"
							className="gs-underline-item effect"
							target="_blank"
						>
							<span className="line">COPYRIGHT 2023 SEOUL NATIONAL UNIVERSITY HOSPITAL.</span>
						</Link>
						All Rights Reserved.
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
